import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const SearchContainer = styled.div`
  border-bottom: 1px solid ${grey};
  flex-shrink: 0;
  padding: 10px;
`;

export default SearchContainer;
